import { useTopBar } from "@hooks/useTopBar";

export const useBanner = () => {
  const { showBanner, setShowBanner } = useTopBar();

  return {
    showBanner,
    setShowBanner,
  };
};
